export type TaskSecondaryQueue = {
  files: File[];
  dossierFileIds: string[];
  comment: string;
};

export const EMPTY_TASK_SECONDARY_QUEUE: TaskSecondaryQueue = {
  files: [],
  dossierFileIds: [],
  comment: '',
};

export function taskSecondaryQueueCount(queue: TaskSecondaryQueue): number {
  const comment = queue.comment.trim() ? 1 : 0;
  return queue.files.length + queue.dossierFileIds.length + comment;
}

export async function flushTaskSecondaryQueue(
  taskId: string,
  queue: TaskSecondaryQueue,
  deps: {
    upload: (taskId: string, file: File) => Promise<unknown>;
    linkFile: (taskId: string, fileId: string, linkedBy: string) => Promise<void>;
    addComment: (taskId: string, content: string) => Promise<unknown>;
    linkedBy: string | null;
  },
): Promise<string[]> {
  const warnings: string[] = [];

  for (const file of queue.files) {
    try {
      await deps.upload(taskId, file);
    } catch {
      warnings.push(`la pièce jointe « ${file.name} » n'a pas pu être envoyée`);
    }
  }

  if (deps.linkedBy) {
    for (const fileId of queue.dossierFileIds) {
      try {
        await deps.linkFile(taskId, fileId, deps.linkedBy);
      } catch {
        warnings.push('un fichier du dossier n’a pas pu être lié');
      }
    }
  }

  const comment = queue.comment.trim();
  if (comment) {
    try {
      await deps.addComment(taskId, comment);
    } catch {
      warnings.push('le commentaire n’a pas pu être enregistré');
    }
  }

  return warnings;
}
